module.exports = "img/mod.bc20c55.svg";